import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export function Card({ children, style, ...rest }: CardProps) {
  return (
    <div
      style={{
        background: 'var(--surface, #FFFFFF)',
        border: '1px solid var(--border, #E0E4E8)',
        borderRadius: 'var(--radius-md, 6px)',
        padding: '16px',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export interface StatCardProps {
  label: string;
  value: string | number;
  note?: string;
}

export function StatCard({ label, value, note }: StatCardProps) {
  return (
    <Card>
      <div style={{ fontSize: '12px', fontWeight: 500, color: 'var(--text-muted, #5B6770)' }}>{label}</div>
      <div style={{ fontSize: '24px', fontWeight: 700, color: 'var(--text, #1A2027)' }}>{value}</div>
      {note ? (
        <div style={{ fontSize: '11px', color: 'var(--text-subtle, #8A94A0)' }}>{note}</div>
      ) : null}
    </Card>
  );
}

export default Card;
